export let action = {
  LOGOUT: "Logout",
  LOGO: "CPV-Auto Batch Processing Platform / CAM 2.1",
  SEARCH: "Search",
  PROJECT: "Project",
  BATCH: "Batch",
  CLEAR: "Clear",
  SETTINGS: "Settings",
  SEARCH_BATCH: "Search Batch..",
  Folder: "Folder",
  File: "File",
  TASKSTATUS: "Task Status",
  AUDITTRAIL: "Audit Trail",
  INVESTIGATION: "Search & Investigate",
  VISUALIZATION: "Visualization",
  DATAPREVIEW: "Data Preview",
  LOGS: "Logs",
  TEMPLATE: "Template",
  DATA_VALIDATION: "Validate Data",
  UNIT_PROCEDURE: "Project",
  MAPPING_VALIDATION: "Validate Mapping",
};
